import forEach from 'lodash/forEach';
import debounce from 'lodash/debounce';
import React, { Component } from 'react';

const defaultModelEvents = 'change';
const defaultCollectionEvents = 'add remove reset sort';

export default (ComponentToWrap, listenerDefs) =>

  class ComponentWithListener extends Component {

    constructor(props) {
      super(props);
      this.debouncedForceUpdate = debounce(()=> {
        if (this._mounted) {
          this.forceUpdate();
        }
      }, 0).bind(this);
      this._mounted = false;
    }

    componentWillMount() {
      this._mounted = true;
      forEach(listenerDefs, (eventNames, propName)=>{
        if (!this.props[propName]) {
          return;
        }
        this.props[propName].on(eventNames, this.debouncedForceUpdate, this);
      });
    }

    componentWillUnmount() {
      this._mounted = false;
      forEach(listenerDefs, (eventNames, propName)=>{
        if (!this.props[propName]) {
          return;
        }
        this.props[propName].off(eventNames, this.debouncedForceUpdate, this);
      });      
    }

    render() {
      return (
        <ComponentToWrap {...this.props} />
      );
    }
  };

export {
  defaultModelEvents,
  defaultCollectionEvents
};